// extracted by mini-css-extract-plugin
export default {"root":"admission_root__m7B-f"};